import React from "react";
import { Typography, Grid, Box, Divider } from "@material-ui/core";
import OffCyclePaymentFormContainer from "./OffCyclePaymentForm/OffCyclePaymentFormContainer";
import EmployeeDisbursementTable from "./EmployeeDisbursementTable/EmployeeDisbursementTable";
import { useEmployeeProfileQuery } from "Hooks/useEmployeeProfileQueryContext";
import { DPPermissionGate } from "Components/DP";
import { HelpText } from "Components/Shared/HelpText/HelpText";
import { DisbursementTimingExplanation } from "Components/Shared/DisbursementTimingExplanation/DisbursementTimingExplanation";

const DisbursementsTab = () => {
  const { userDetails } = useEmployeeProfileQuery();
  const employeeProfileId = userDetails ? userDetails.id : "";

  // Arbitrarily select first provider account to send disbursement to
  const providerAccountId = userDetails
    ? userDetails.providerAccounts.items[0].id
    : "";

  const primaryExternalId =
    userDetails?.externalIds.find((identifier) => identifier.primary)?.id || "";

  return (
    <Grid container direction={"column"} spacing={2}>
      <DPPermissionGate permissionKeys={["canCreateDisbursements"]}>
        <Grid item>
          <HelpText disableTypography>
            <Typography>
              Please enter information of the individual to whom you would like
              to disburse money using "Same Day ACH".
            </Typography>
            <DisbursementTimingExplanation />
          </HelpText>
        </Grid>
        <Grid item>
          <Typography variant="h3">Make an Off-Cycle Payment</Typography>
        </Grid>
        <Grid item>
          <Box padding={2}>
            {userDetails && (
              <OffCyclePaymentFormContainer
                employeeProfileId={employeeProfileId}
                providerAccountId={providerAccountId}
                userId={primaryExternalId}
              />
            )}
          </Box>
        </Grid>
        <Divider />
      </DPPermissionGate>
      <EmployeeDisbursementTable employeeProfileId={employeeProfileId} />
    </Grid>
  );
};

export default DisbursementsTab;
